module.exports = __webpack_public_path__ + "img/cafe.e042ab14.png";